import {MESSAGE, SnackbarType} from "../constants/appConstants";
import {SET_SNACKBAR} from "../reducers/snackbarReducer";

export const successRegisterUser = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.SUCCESS,
    snackbarMessage: MESSAGE.REGISTER_USER_SUCCESS
}

export const successAddJamaat = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.SUCCESS,
    snackbarMessage: MESSAGE.ADD_JAMAAT_SUCCESS
}

export const errorAddJamaat = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.ADD_JAMAAT_FAILURE
}

export const successAddNotification = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.SUCCESS,
    snackbarMessage: MESSAGE.ADD_NOTIFICATION_SUCCESS
}

export const errorAddNotification = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.ADD_NOTIFICATION_FAILURE
}

export const errorRegisterUser = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.REGISTER_USER_ERROR
}

export const errorFetchApplicants = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.FETCH_APPLICANTS_ERROR
}

export const errorFetchJamaats = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.FETCH_JAMAATS_ERROR
}

export const errorLoginUser = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.LOGIN_USER_ERROR
}

//for events
export const successAddEvent = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.SUCCESS,
    snackbarMessage: MESSAGE.ADD_EVENTS_SUCCESS
}

export const errorAddEvent = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.ADD_EVENTS_FALIURE
}
export const errorFetchEvents = {
    type: SET_SNACKBAR,
    snackbarOpen: true,
    snackbarType: SnackbarType.ERROR,
    snackbarMessage: MESSAGE.FETCH_EVENTS_ERROR
}

export const successSnackbar = (message) => {
    return {
        type: SET_SNACKBAR,
        snackbarOpen: true,
        snackbarType: SnackbarType.SUCCESS,
        snackbarMessage: message
    }
}

export const errorSnackbar = (message) => {
    return {
        type: SET_SNACKBAR,
        snackbarOpen: true,
        snackbarType: SnackbarType.ERROR,
        snackbarMessage: message
    }
}
